import { useReader } from "../ReaderContext";

export const CoverPage = ({ page }) => {
  const { edition } = useReader();
  const [a, b, c, d] = page.items || [];
  const Line = ({ it, align }) =>
    it ? (
      <div className={align === "right" ? "text-right" : ""}>
        <div className="font-head font-bold uppercase" style={{ fontSize: 22, color: "var(--bordeaux)", letterSpacing: "0.01em", lineHeight: 1 }}>{it.title}</div>
        <div className="font-head" style={{ fontSize: 13.5, lineHeight: 1.15, marginTop: 3, color: "var(--charcoal)" }}>{it.text}</div>
      </div>
    ) : null;
  return (
    <article className="mag-page" data-testid="mag-page-1" lang={edition?.lang} dir={edition?.dir || "ltr"}>
      <img src={page.image} alt="ROOTS cover portrait" className="mag-img absolute inset-0" />
      <div className="absolute top-3 left-0 right-0 text-center mag-kicker" style={{ color: "var(--bordeaux)", fontSize: 8.5 }} data-testid="cover-edition-line">{page.kicker}</div>
      <div className="absolute font-head italic" style={{ top: 143, left: 24, fontSize: 13.5, color: "var(--bordeaux)" }} data-testid="cover-tagline">{edition?.tagline}</div>
      <div className="absolute flex flex-col gap-5" style={{ top: 300, left: 24, width: 130 }}>
        <Line it={a} /><Line it={b} />
      </div>
      <div className="absolute flex flex-col gap-5" style={{ top: 300, right: 24, width: 140 }}>
        <Line it={c} align="right" /><Line it={d} align="right" />
      </div>
      <div className="absolute left-6 right-6" style={{ bottom: 78 }}>
        <h1 className="font-head font-bold uppercase" style={{ fontSize: 66, lineHeight: 0.88, color: "var(--cream)", letterSpacing: "-0.02em", textShadow: "0 2px 18px rgba(0,0,0,0.35)", maxWidth: 480 }} data-testid="cover-headline">
          {page.title}
        </h1>
        <p className="font-head italic mt-3" style={{ fontSize: 15, color: "var(--cream)", maxWidth: 380, lineHeight: 1.25, textShadow: "0 1px 10px rgba(0,0,0,0.5)" }}>{page.deck}</p>
      </div>
      <div className="absolute bottom-5 left-0 right-0 text-center mag-kicker" style={{ color: "var(--cream)", fontSize: 8.5, letterSpacing: "0.34em" }}>{page.note}</div>
    </article>
  );
};
